/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';

  /**
   * Хелпер для форматирования телефонных номеров. Использует underscore.js
   */
  app.helpers.PhoneHelper = {
    /**
     * Возвращает отформатированный номер
     * @param number номер телефона
     * @param options опции
     * @returns {String} отформатированный по маске номер
     */
    getFormatedPhoneNumber: function (number, options) {
      var DEFAULT_OPTIONS = {
          mask: '+# ### ###-##-##',
          placeholder: '#',
          find_mask: true, //нужно ли искать маску в app.phoneCodes
          no_default_mask: false //не применять дефолтную маску, если маска не найдена в массиве
        },
        phoneNumber,
        mask;

      if (typeof number !== 'string'){
        throw new Error('number '+ number + ' should be string');
      }
      // Оставляем только цифры
      phoneNumber = number.replace(/\D/g, '');

      // Если переданы опции, соединяем их с дефолтными опциями
      if (options){
        if (options.no_default_mask){
          delete DEFAULT_OPTIONS.mask;
        }
        if (options.mask){
          options.find_mask = false;
        }
        options = _.extend(_.clone(DEFAULT_OPTIONS), options);
      } else {
        options = _.clone(DEFAULT_OPTIONS);
      }
      mask = options.mask;
      // Ищем маску в app.phoneCodes, если есть опция
      if (options.find_mask){
        var findMask = this.getPhoneMask(phoneNumber);
        if (findMask){
          mask = findMask;
        }

        // Если не нашли, проверяем является ли телефон внутренним российским.
        // Если да, применяем маску для России, заменяем в номере 8 на 7
        if (!findMask && this._isRussianInternalNumber(phoneNumber)){
          phoneNumber = 7 + phoneNumber.slice(1);
          mask = app.helpers.PhoneHelper.russiaPhoneCode.mask;
        }
      }
      // Если маска не была найдена, не передана в опциях и есть опция "no_default_mask",
      // возвращаем неформатированный номер
      if (!mask){
        return number;
      }

      return this._applyMask(phoneNumber, mask, options.placeholder);
    },

    /**
     * Ищет маску для номера телефона в app.phoneCodes
     * @param phone {String} номер телефона
     * @returns {String} маска вида "+7 ### ###-##-##"
     */
    getPhoneMask: function(phone){
      if (typeof phone !== 'string'){
        throw new Error('number '+ phone + ' should be string');
      }

      var i, codes = app.phoneCodes;

      return codes.reduce(function (foundMask, item) {
        if (Array.isArray(item.submasks_cleared)) {
          for (i = 0; i < item.submasks_cleared.length; i++) {
            if (app.helpers.PhoneHelper._compareMask(phone, item.submasks_cleared[i])) {
              foundMask = item.submasks[i];
            }
          }
        } else if (app.helpers.PhoneHelper._compareMask(phone, item.mask_cleared)) {
          foundMask = item.mask;
        }
        return foundMask;
      }, '');
    },

    /**
     * Определяет, подходит ли маска для данного номера телефона
     * @param number {String} номер телефона
     * @param mask {String} маска
     * @returns {boolean}
     * @private
     */
    _compareMask: function (number, mask) {
      if (typeof number !== 'string'){
        throw new Error('number '+ number + ' should be string');
      }
      if (!mask){
        return false;
      }
      if(number.length !== mask.length){
        return false;
      }

      for (var i = 0; i < mask.length; i++){
        //Если символ маски не совпадает с символом номера и не является символом "#", возвращаем false
        if (number[i] !== mask[i] && mask[i] !== '#') {
          return false;
        }
      }
      return true;
    },

    /**
     * Является ли телефон внутренним российским
     * @param phoneNumber
     * @returns {boolean}
     * @private
     */
    _isRussianInternalNumber: function (phoneNumber) {
      if (!phoneNumber){
        return false;
      }
      if (typeof phoneNumber !== 'string'){
        throw new Error('phoneNumber '+ phoneNumber +' should be string');
      }

      if (!app.helpers.PhoneHelper.russiaPhoneCode){
        // Храним маску для России в app.helpers.PhoneHelper, чтобы не искать ее каждый раз
        var russiaPhoneCodeIndex = _.findKey(app.phoneCodes, function(x){
          return x.cc === 'RU';
        });
        app.helpers.PhoneHelper.russiaPhoneCode = app.phoneCodes[russiaPhoneCodeIndex];
      }

      return (phoneNumber.length === 11 && phoneNumber[0] === '8');
    },

    _applyMask: function (phoneNumber, mask, placeholder) {
      var reg,
        digitsArray,
        numberOfDigits,
        resultArr,
        phoneNumberArray;

      if (typeof phoneNumber !== 'string'){
        throw new Error('phoneNumber '+ phoneNumber +' should be string');
      }

      if (!phoneNumber || !mask || !placeholder){
        return '';
      }

      mask = String(mask).replace(/[0-9]/g, placeholder);

      // Считаем количество цифр в маске
      reg = new RegExp('[0-9'+ placeholder + ']', 'g');
      digitsArray = mask.match(reg);
      numberOfDigits = digitsArray ? digitsArray.length : 0;

      // Разбиваем маску и номер на массив и разворачиваем,
      // чтобы подставлять номер в маску с конца
      resultArr = mask.split('').reverse();
      phoneNumberArray = phoneNumber.split('').reverse();

      for (var i = 0; i < resultArr.length; i++){
        if (phoneNumberArray.length){
          // Заменяем символы маски на цифры номера
          if (resultArr[i] === placeholder){
            //Если в маске остался последний плейсхолдер, а в номере больше одной цифры,
            // заменяем плейсхолдер на оставшивеся цифры номера и убираем оставшиеся символы в маске.
            if (numberOfDigits === 1 && phoneNumberArray.length > 1) {
              resultArr[i] = phoneNumberArray.reverse().join('');
              resultArr.splice(i+1, resultArr.length);
            } else {
              resultArr[i] = phoneNumberArray.shift();
              numberOfDigits--;
            }
          }
        } else {
          // Если цифры номера кончились, но маска ожидает еще цифры,
          // удаляем оставшиеся символы. В противном случае выходим из цикла не меняя результат.
          if (resultArr.slice(i).join('').match(reg)){
            resultArr.splice(i, resultArr.length);
          } else {
            break;
          }
        }
      }

      return resultArr.reverse().join('');
    },
    /**
     * Позволяет узнать страну по номеру.
     * @param number
     * @returns {*} объект нужной страны из справочника стран
     */
    getCountryCodeFromNumber: function (number) {
      var shortNumber = String(number).replace(/\D/g, '').slice(0, 3),
        key = 'other',
        numberMap = {
          '373': 'moldova',
          '374': 'armenia',
          '375': 'belarus',
          '380': 'ukraine',
          '992': 'tajikistan',
          '993': 'turkmenistan',
          '994': 'azerbaijan',
          '995': 'georgia',
          '996': 'kyrgyzstan',
          '998': 'uzbekistan'
        };
      if (shortNumber[0] === '7') {
        if (shortNumber[1] === '6' || shortNumber[1] === '7') {
          key = 'kazakhstan';
        } else {
          key = 'russia';
        }
      }
      return numberMap[shortNumber] ? app.countryFlags[numberMap[shortNumber]] : app.countryFlags[key];
    }
  };
})();

}.call(window));